import { MATURATION_CYCLE_OPTIONS } from '../../../constants/maturationCycles.constants';
import type { ParcellingMaturationCycle } from '../../../types';
import { CustomSelect } from '../../Inputs/CustomSelect/CustomSelect';
import styles from '../ParcellingFormSection/ParcellingFormSection.module.css';

export const MaturationCycleField = ({ value, onChange, isEditing, error }: {
	value?: ParcellingMaturationCycle;
	onChange: (value: ParcellingMaturationCycle) => void;
	isEditing: boolean;
	error?: string;
}) => (
	<div className={styles.field}>
		<p className={`${styles.label} ${error ? styles.labelError : ''}`}>Ciclo de maturação</p>
		{isEditing ? <CustomSelect value={value ?? ''} onChange={(selected) => onChange(selected as ParcellingMaturationCycle)} options={MATURATION_CYCLE_OPTIONS} placeholder="Selecionar..." error={error} />
			: <span className={styles.value}>{MATURATION_CYCLE_OPTIONS.find((option) => option.value === value)?.label ?? '-'}</span>}
	</div>
);
